const e=async(e,t,n)=>{await e.put(`/users/${t}`,n)};export{e as updateUser};
//# sourceMappingURL=update-user.mjs.map